// @ts-nocheck
/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import useAppStore from '../store';
import useAdminStore from '../store/adminStore';
import ExistingStaffTable from '../components/aenderungszentrale/ExistingStaffTable';
import NewStaffTable from '../components/aenderungszentrale/NewStaffTable';
import EntrepreneurTable from '../components/aenderungszentrale/EntrepreneurTable';
import ClientMasterTable from '../components/aenderungszentrale/ClientMasterTable';
import CostsTable from '../components/aenderungszentrale/CostsTable';
import OpeningHoursTable from '../components/aenderungszentrale/OpeningHoursTable';
import { StaffBonusOverviewModal } from '../components/teamBonus';
import {
    CHANGE_REQUESTS_COLLECTION,
    resolveChangeRequestType,
} from '../types/changeRadar';
import useChangeRadarStore from '../store/changeRadarStore';

const STORAGE_KEY = "pe_aenderungszentrale_v1_draft";

const COACH_FALLBACKS: Record<string, string> = {
    'Christian': 'erfolg@friseur-coaching.de',
    'Christian Funk': 'erfolg@friseur-coaching.de',
    'Martina': 'coaching@preisexpert.info',
    'Martina Jovanovic': 'coaching@preisexpert.info',
    'Jean': 'Jean@unisex-friseur.style',
    'Jean Standard': 'Jean@unisex-friseur.style',
    'Nelly': 'Nelly@skaadi.de',
    'Nelly Rühle': 'Nelly@skaadi.de'
};

const ADMIN_USERS = ['Christian', 'Martina', 'Jean', 'Nelly', 'Omar'];
const ADMIN_PASSWORD = '90';

interface AenderungsZentralePageProps {
    navigateTo?: (pageKey: string) => void;
}

const AenderungsZentralePage: React.FC<AenderungsZentralePageProps> = ({ navigateTo }) => {
  const { clientData, settings, team, setDraftLockStatus } = useAppStore();

  const currencyLabel = settings?.country?.currency === 'CHF' ? 'CHF' : 'EUR';

  // --- STATE ---
  const [showSendModal, setShowSendModal] = useState(false);
  const [sendForm, setSendForm] = useState({ name: '', message: '' }); 
  const [emailError, setEmailError] = useState(false);
  const [requestSecondHalf, setRequestSecondHalf] = useState(false); // NEU: Checkbox für das 2. Halbjahr
  
  // UI FEEDBACK STATES
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [bonusModalOpen, setBonusModalOpen] = useState(false);
  
  // Fester Horizontal-Scroll für die gesamte Seite (nicht pro Tabelle)
  const hScrollRef = useRef<HTMLDivElement | null>(null);
  const hSpacerRef = useRef<HTMLDivElement | null>(null);
  const syncingScrollRef = useRef(false);

  // ADMIN LOCK STATE
  const [lockModalOpen, setLockModalOpen] = useState(false);
  const [lockStep, setLockStep] = useState(1);
  const [lockTarget, setLockTarget] = useState<{id: string, category: string, isLocked: boolean} | null>(null);
  const [adminPwd, setAdminPwd] = useState('');
  const [selectedCoach, setSelectedCoach] = useState('');

  // SECTIONS
  const [collapsed, setCollapsed] = useState({ existing: true, newStaff: true, entrepreneur: true, clientData: true, costs: true, hours: true });

  // --- HELPER ---
  const getCoachDetails = () => {
      const betreuerRaw = clientData.betreuer || '';
      let coach = team?.find((t: any) => t.id === betreuerRaw);
      if (!coach && team) coach = team.find((t: any) => t.name === betreuerRaw || (t.firstName && betreuerRaw.includes(t.firstName)));
      let displayName = coach ? (coach.name || `${coach.firstName} ${coach.lastName}`) : (COACH_FALLBACKS[betreuerRaw] ? betreuerRaw : (betreuerRaw || 'Support Team'));
      let displayEmail = coach ? coach.email : (COACH_FALLBACKS[betreuerRaw] || 'support@preisexpert.de');
      return { name: displayName, email: displayEmail };
  };

  // --- ADMIN HANDLERS ---
  const handleAdminLock = (id: string, category: string, isLocked: boolean) => {
      setLockTarget({ id, category, isLocked });
      setLockStep(1); setAdminPwd(''); setSelectedCoach(''); setLockModalOpen(true);
      setTimeout(() => document.getElementById('adminPwdInput')?.focus(), 100);
  };

  const processAdminStep1 = () => {
      if (adminPwd === ADMIN_PASSWORD) {
          if (lockTarget?.isLocked) setLockStep(3); else setLockStep(2);
      } else { (window as any).showToast("Falsches Passwort!", "error"); }
  };

  const processLocking = () => {
      if (!selectedCoach) { (window as any).showToast("Bitte einen Betreuer wählen!", "error"); return; }
      if (lockTarget) {
          setDraftLockStatus(lockTarget.category as any, lockTarget.id, true, selectedCoach);
          setLockModalOpen(false); (window as any).showToast("Zeile erfolgreich gesperrt.", "success");

          // Change-Radar: pending Tickets dieses Mandanten lautlos → Erledigt/Archiv
          try {
              const impersonatedId = useAdminStore.getState().impersonatedClientId;
              const clientId = impersonatedId || auth.currentUser?.uid || '';
              const coachUid = auth.currentUser?.uid || '';
              if (clientId) {
                  void useChangeRadarStore
                      .getState()
                      .resolvePendingForClient(clientId, coachUid, selectedCoach)
                      .catch((err) => console.warn('resolvePendingForClient:', err));
              }
          } catch (err) {
              console.warn('Change-Radar Auto-Resolve nach Sperre:', err);
          }
      }
  };

  const processUnlocking = () => {
      if (lockTarget) {
          setDraftLockStatus(lockTarget.category as any, lockTarget.id, false);
          setLockModalOpen(false); (window as any).showToast("Zeile wieder freigegeben.", "info");
      }
  };

  const showErrorPopup = (title, msg) => {
        const modal = document.getElementById('errorModal');
        const tEl = document.getElementById('errorModalTitle');
        const mEl = document.getElementById('errorModalText');
        if(modal && tEl && mEl) {
            tEl.textContent = title; mEl.innerHTML = msg;
            modal.classList.add('open'); modal.style.display = 'flex';
            setTimeout(() => {
                const firstError = document.querySelector('.input-error-highlight') || document.querySelector('.input-error'); 
                if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 300);
        } else { alert(title + "\n\n" + msg); }
  };

  const toNumSafe = (val: any) => {
      if (val === undefined || val === null || val === '') return 0;
      if (typeof val === 'number') return Number.isFinite(val) ? val : 0;
      let clean = String(val)
          .replace(/\u00a0/g, ' ')
          .replace(/[€$£CHF\s]/gi, '')
          .trim();
      if (!clean) return 0;
      // DE: 1.234,56 → 1234.56 | nur Komma: 600,00 → 600.00 | nur Punkt: 600.5
      if (clean.includes(',') && clean.includes('.')) {
          clean = clean.replace(/\./g, '').replace(',', '.');
      } else if (clean.includes(',')) {
          clean = clean.replace(',', '.');
      }
      const n = parseFloat(clean);
      return Number.isFinite(n) ? n : 0;
  };

  const hasManualChanges = (draft: any, category: string, dataSource?: any) => {
      const cd = dataSource || clientData;

      const toStr = (val: any) => String(val || '').trim();

      const isDiff = (valA: any, valB: any) => {
          return Math.abs(toNumSafe(valA) - toNumSafe(valB)) > 0.01;
      };

      if (category === 'entrepreneur') {
          const orig = cd.unternehmerData || {};
          if (isDiff(draft.inputs.entnahme, orig.entnahme)) return true;
          if (isDiff(draft.inputs.social, orig.sozialkosten)) return true;
          if (isDiff(draft.inputs.umsatz, orig.durchschnittsumsatz)) return true;
          if (isDiff(draft.inputs.hours, orig.prodWochenstunden)) return true;
          if (isDiff(draft.inputs.days, orig.prodWochentage)) return true;
          if (draft.inputs.notes && toStr(draft.inputs.notes) !== '') return true;
      }

      if (category === 'existingStaff') {
          // Store-Flag (nach Blur/Sync) — zusätzlich zur Feld-Diff
          if (draft.hasChanges === true) return true;

          const lookupId = draft.originalId || draft.id;
          const allOrig = [
              ...(cd.personalData || []).map((p: any) => ({ ...p, _sourceType: 'Produktiv (auch prod. Azubi)' })),
              ...(cd.unproductivePersonalData || []).map((p: any) => ({ ...p, _sourceType: 'Unproduktiv' })),
              ...(cd.azubiAssistenzData || []).map((p: any) => ({ ...p, _sourceType: 'Azubi & Assistenz' })),
          ];
          const orig =
              allOrig.find((p: any) => p && p.id === draft.id) ||
              allOrig.find((p: any) => p && p.id === lookupId);
          if (orig) {
              let cmpBase = orig.grundgehalt;
              let cmpHours = orig.wochenstunden;
              if (toStr(orig._sourceType) === 'Produktiv (auch prod. Azubi)') {
                  const linkedUnprods = (cd.unproductivePersonalData || []).filter((u: any) => {
                      if (!u || String(u.taetigkeit || '').trim() !== 'Unprod. Anteil') return false;
                      if (u.isSplitDeduction === false) return false;
                      if (String(u.linkedProductiveEmployeeId || '') === String(orig.id)) return true;
                      if (
                          !u.linkedProductiveEmployeeId &&
                          orig.name &&
                          String(u.name || '').trim() === String(orig.name || '').trim()
                      ) {
                          return true;
                      }
                      return false;
                  });
                  for (const u of linkedUnprods) {
                      cmpBase = Math.max(0, (Number(cmpBase) || 0) - (Number(u.grundgehalt) || 0));
                      cmpHours = Math.max(0, (Number(cmpHours) || 0) - (Number(u.wochenstunden) || 0));
                  }
              }

              if (isDiff(draft.inputs.base, cmpBase)) return true;
              if (isDiff(draft.inputs.add, orig.lohnzusatz)) return true;
              if (isDiff(draft.inputs.bonus, orig.bonus)) return true;
              if (isDiff(draft.inputs.hours, cmpHours)) return true;
              if (isDiff(draft.inputs.days, orig.arbeitstage)) return true;
              
              const inputType = toStr(draft.inputs.type);
              const origType = toStr(orig._sourceType);
              if (inputType !== '' && origType !== '' && inputType !== origType) return true;

              const inputRole = toStr(draft.inputs.role);
              const origRole = toStr(orig.taetigkeit);
              if (inputRole !== '' && inputRole !== origRole) return true;

              if (
                  draft.inputs.linkedProductiveEmployeeId !== undefined &&
                  toStr(draft.inputs.linkedProductiveEmployeeId) !== toStr(orig.linkedProductiveEmployeeId)
              ) {
                  return true;
              }
              if (
                  draft.inputs.isSplitDeduction !== undefined &&
                  Boolean(draft.inputs.isSplitDeduction) !== (orig.isSplitDeduction !== false)
              ) {
                  return true;
              }
              if (draft.inputs.isNewUnprodAnteil) return true;

              if (toStr(draft.inputs.type) === 'Austritt') return true;

              if (draft.inputs.notes && toStr(draft.inputs.notes) !== '') return true;
          } else if (draft.inputs && draft.inputs.date) {
              // Kein Original gefunden, aber aktive Zeile → nicht als „leer“ verwerfen
              return true;
          }
      }

      if (category === 'clientMaster') {
          const orig = cd;
          const checkField = (inputKey: string, origKey: string) => {
              return toStr(draft.inputs[inputKey]).toLowerCase() !== toStr(orig[origKey]).toLowerCase();
          };
          
          if (checkField('unternehmername', 'unternehmername')) return true;
          if (checkField('firmenname', 'firmenname')) return true;
          if (checkField('unternehmensform', 'unternehmensform')) return true;
          if (checkField('strasse', 'strasse')) return true;
          if (checkField('plz', 'plz')) return true;
          if (checkField('ort', 'ort')) return true;
          if (checkField('mailadresse', 'mailadresse')) return true;
          if (checkField('telefonnummer', 'telefonnummer')) return true;
          if (checkField('websiteUrl', 'websiteUrl')) return true;
          if (checkField('socialMedia', 'socialMedia')) return true;
      }

      if (category === 'openingHours') {
          const orig = cd.unternehmerData?.geoeffneteStunden || [0,0,0,0,0,0];
          if (isDiff(draft.inputs.mon, orig[0])) return true;
          if (isDiff(draft.inputs.tue, orig[1])) return true;
          if (isDiff(draft.inputs.wed, orig[2])) return true;
          if (isDiff(draft.inputs.thu, orig[3])) return true;
          if (isDiff(draft.inputs.fri, orig[4])) return true;
          if (isDiff(draft.inputs.sat, orig[5])) return true;
          if (draft.inputs.notes && toStr(draft.inputs.notes) !== '') return true;
      }

      return false;
  };

  /** Offene Inputs (localValues) per Blur in den Store flushen, dann frischen Store lesen. */
  const flushDraftInputsToStore = () => {
      const el = document.activeElement;
      if (el && el instanceof HTMLElement && typeof el.blur === 'function') {
          el.blur();
      }
  };

  const validateSubmission = () => {
        flushDraftInputsToStore();
        const fresh = useAppStore.getState().clientData;

        let hasActiveDrafts = false;
        let hasRealChanges = false;
        const errors: string[] = [];

        const check = (d: any, label: string, category: string, isCost = false) => {
            if (d.inputs && d.inputs.date && d.inputs.date !== '') {
                hasActiveDrafts = true;
                
                let changed = false;

                if (category === 'existingStaff' || category === 'entrepreneur' || category === 'clientMaster' || category === 'openingHours') {
                    if (hasManualChanges(d, category, fresh)) {
                        changed = true;
                    }
                } 
                else if (category === 'newStaff') {
                    changed = true; 
                } 
                else if (isCost) {
                    const type = d.inputs?.type || '';
                    const cat = String(d.inputs?.category || '').trim();
                    const det = String(d.inputs?.detail || '').trim();
                    const valNum = toNumSafe(d.inputs?.newValue);
                    
                    if (type !== '' || cat !== '' || det !== '' || Math.abs(valNum) > 0.01) {
                        changed = true;
                    }
                }

                if (changed) {
                    hasRealChanges = true;
                } else {
                    const fallbackName = d.name || d.inputs.name || d.inputs.unternehmername || d.inputs.firmenname || d.inputs.detail || d.inputs.category || 'Leere Zeile';
                    errors.push(`${label}: ${fallbackName} (Werte unverändert)`);
                }

                if (category === 'newStaff') {
                    const g = toNumSafe(d.inputs.base);
                    const s = toNumSafe(d.inputs.hours);
                    
                    if (g <= 0 || s <= 0) {
                        errors.push(`Neuer MA: ${d.inputs.name || 'Neu'} - Gehalt/Stunden fehlen`);
                        hasRealChanges = false; 
                    }
                }

                if (isCost && changed) {
                    const type = d.inputs?.type || '';
                    const cat = String(d.inputs?.category || '').trim();
                    const det = String(d.inputs?.detail || '').trim();
                    const valNum = toNumSafe(d.inputs?.newValue);
                    
                    if (type === '') {
                        errors.push(`Kosten: Art der Änderung fehlt`);
                        hasRealChanges = false;
                    } else if (type === 'new' && det === '') {
                        errors.push(`Kosten: Neue Position - Bezeichnung fehlt`);
                        hasRealChanges = false;
                    } else if ((type === 'flat' || type === 'part') && cat === '') {
                        errors.push(`Kosten: Bestehende Position - Kategorie fehlt`);
                        hasRealChanges = false;
                    } else if (Math.abs(valNum) < 0.01) {
                        errors.push(`Kosten: ${det || cat || 'Unbekannte Position'} - Betrag ist 0,00`);
                        hasRealChanges = false;
                    }
                }
            }
        };

        Object.values(fresh.drafts?.existingStaff || {}).forEach((d: any) => check(d, 'Mitarbeiter', 'existingStaff'));
        (fresh.drafts?.newStaff || []).forEach((d: any) => check(d, 'Neuer MA', 'newStaff'));
        (fresh.drafts?.entrepreneur || []).forEach((d: any) => check(d, 'Unternehmer', 'entrepreneur'));
        (fresh.drafts?.clientMaster || []).forEach((d: any) => check(d, 'Mandantendaten', 'clientMaster'));
        (fresh.drafts?.costs || []).forEach((d: any) => check(d, 'Kosten', 'costs', true));
        (fresh.drafts?.openingHours || []).forEach((d: any) => check(d, 'Öffnungszeiten', 'openingHours'));

        const jokerDates = document.querySelectorAll('select.field-date');
        let jokerActive = false;
        jokerDates.forEach((el: any) => {
            if (el.value !== '' && !el.disabled && !el.closest('.active-row')) jokerActive = true;
        });

        if (jokerActive) {
            showErrorPopup("Nicht gespeichert!", "Du hast unten noch eine offene Eingabe (Datum gewählt).<br>Bitte schließe die Zeile ab oder lösche das Datum (Reset-Button).");
            return false;
        }

        if (errors.length > 0) {
            showErrorPopup("Fehlerhafte oder leere Einträge!", `Das System hat unvollständige oder unveränderte Zeilen gefunden.<br><br>Betroffen:<br>• ${errors.join('<br>• ')}<br><br><i>Tipp: Lösche leere Zeilen mit dem Papierkorb/Reset-Button!</i>`);
            return false;
        }

        // Leer erlaubt: Modal öffnen für reinen HJ2-Antrag (Checkbox im Dialog).
        // executeSend erzwingt hasRealChanges || requestSecondHalf.
        return true;
  };

  const saveAndClean = () => {
        const sectionUpdates: Record<string, boolean> = {};

        const hasData = (storeCheck: boolean, domId: string) => {
            if (storeCheck) return true; 
            const container = document.getElementById(domId);
            if (container) {
                const dates = container.querySelectorAll('select.field-date');
                for (let i = 0; i < dates.length; i++) {
                    const val = (dates[i] as HTMLSelectElement).value;
                    if (val && val !== '') return true; 
                }
            }
            return false; 
        };

        const exDrafts = clientData.drafts?.existingStaff || {};
        sectionUpdates['existing'] = !hasData(Object.values(exDrafts).some((d: any) => d.inputs.date !== ''), 'existingStaffBody');

        const newDrafts = clientData.drafts?.newStaff || [];
        sectionUpdates['newStaff'] = !hasData(newDrafts.some((d: any) => d.inputs.date !== ''), 'newStaffBody');

        const entDrafts = clientData.drafts?.entrepreneur || [];
        sectionUpdates['entrepreneur'] = !hasData(entDrafts.some((d: any) => d.inputs.date !== ''), 'entrepreneurBody');

        const cmDrafts = clientData.drafts?.clientMaster || [];
        sectionUpdates['clientData'] = !hasData(cmDrafts.some((d: any) => d.inputs.date !== ''), 'clientMasterBody');

        const costDrafts = clientData.drafts?.costs || [];
        sectionUpdates['costs'] = !hasData(costDrafts.some((d: any) => d.inputs.date !== ''), 'costsBody');

        const hoursDrafts = clientData.drafts?.openingHours || [];
        sectionUpdates['hours'] = !hasData(hoursDrafts.some((d: any) => d.inputs.date !== ''), 'openingHoursBody');

        setCollapsed(prev => ({ ...prev, ...sectionUpdates }));
        if ((window as any).salaryChanged) { document.getElementById('salaryCheckModal').classList.add('open'); return; } 
        
        (window as any).isDataSaved = true; 
        const submitBtn = document.getElementById('submitBtn'); 
        if(submitBtn) submitBtn.classList.remove('disabled'); 
        const btn = document.querySelector('.btn-clean'); 
        if(btn) {
            const origText = btn.innerHTML; 
            btn.innerHTML = '<i class="fas fa-check"></i> Gespeichert!'; 
            setTimeout(() => { btn.innerHTML = origText; }, 2000); 
        }
        (window as any).showToast("Gespeichert! Bereit zum Absenden.", 'success'); 
  };

  const toggleSection = (section: string) => { 
      if (collapsed[section]) {
          setCollapsed(prev => ({ ...prev, [section]: false }));
          return;
      }

      let isBlocked = false;
      const domIdMap: Record<string, string> = {
          'existing': 'existingStaffBody',
          'newStaff': 'newStaffBody',
          'entrepreneur': 'entrepreneurBody',
          'clientData': 'clientMasterBody',
          'costs': 'costsBody',
          'hours': 'openingHoursBody'
      };

      const domId = domIdMap[section];
      if (domId) {
          const container = document.getElementById(domId);
          if (container) {
              const dates = container.querySelectorAll('select.field-date');
              for(let i=0; i<dates.length; i++) {
                  const val = (dates[i] as HTMLSelectElement).value;
                  if (val && val !== '') {
                      isBlocked = true;
                      break;
                  }
              }
          }
      }

      if (isBlocked) {
          (window as any).showToast("Bereich ist aktiv (Datum gewählt) und kann nicht geschlossen werden.", "error");
      } else {
          setCollapsed(prev => ({ ...prev, [section]: true }));
      }
  };

  const handleOpenSendModal = () => {
      if (!validateSubmission()) return;
      setSendForm({ name: clientData.unternehmername || '', message: '' });
      setRequestSecondHalf(false); // NEU: Zurücksetzen beim Öffnen
      setEmailError(false);
      setIsSubmitting(false);
      setShowSuccess(false);
      setShowSendModal(true);
  };

  /** Spiegel der Draft-Prüfung aus validateSubmission (ohne Popups) — für type/unlock_h2-Payload. */
  const detectHasRealChanges = () => {
      flushDraftInputsToStore();
      const fresh = useAppStore.getState().clientData;
      let hasRealChanges = false;
      const check = (d: any, category: string, isCost = false) => {
          if (!(d.inputs && d.inputs.date && d.inputs.date !== '')) return;
          if (category === 'existingStaff' || category === 'entrepreneur' || category === 'clientMaster' || category === 'openingHours') {
              if (hasManualChanges(d, category, fresh)) hasRealChanges = true;
          } else if (category === 'newStaff') {
              hasRealChanges = true;
          } else if (isCost) {
              const type = d.inputs?.type || '';
              const cat = String(d.inputs?.category || '').trim();
              const det = String(d.inputs?.detail || '').trim();
              const valNum = toNumSafe(d.inputs?.newValue);
              if (type !== '' || cat !== '' || det !== '' || Math.abs(valNum) > 0.01) hasRealChanges = true;
          }
      };
      Object.values(fresh.drafts?.existingStaff || {}).forEach((d: any) => check(d, 'existingStaff'));
      (fresh.drafts?.newStaff || []).forEach((d: any) => check(d, 'newStaff'));
      (fresh.drafts?.entrepreneur || []).forEach((d: any) => check(d, 'entrepreneur'));
      (fresh.drafts?.clientMaster || []).forEach((d: any) => check(d, 'clientMaster'));
      (fresh.drafts?.costs || []).forEach((d: any) => check(d, 'costs', true));
      (fresh.drafts?.openingHours || []).forEach((d: any) => check(d, 'openingHours'));
      return hasRealChanges;
  };

  const executeSend = async () => {
      const storedEmail = clientData.mailadresse;
      if (!storedEmail) { (window as any).showToast("Keine Absender-Mail hinterlegt!", 'error'); return; }

      const hasOtherChanges = detectHasRealChanges();
      if (!hasOtherChanges && !requestSecondHalf) {
          (window as any).showToast("Bitte Änderungen vornehmen oder Freischaltung 2. Halbjahr anhaken.", 'error');
          return;
      }
      
      setIsSubmitting(true);

      try {
          const user = auth.currentUser;
          if (!user) {
              throw new Error('Nicht angemeldet');
          }
          const impersonatedId = useAdminStore.getState().impersonatedClientId;
          const clientId = impersonatedId || user.uid;
          const unlock_h2 = !!requestSecondHalf;
          const ticketType = resolveChangeRequestType(unlock_h2, hasOtherChanges);
          const coachDetails = getCoachDetails();
          const coachEmail = String(coachDetails.email || '').trim();
          if (!coachEmail) {
              throw new Error('Keine Coach-E-Mail gefunden');
          }

          const firmenname = clientData.firmenname || sendForm.name || 'Mandant';
          const mandantNr = clientData.mandantNr || '';
          const typeLabelDe =
              ticketType === 'both'
                  ? 'Stammdaten-Änderung + HJ2-Freischaltung'
                  : ticketType === 'unlock_h2'
                    ? 'HJ2-Freischaltung'
                    : 'Stammdaten-Änderung';
          const senderName =
              String(clientData.unternehmername || '').trim() ||
              String(sendForm.name || '').trim() ||
              firmenname;
          const notes = sendForm.message || 'Bitte Änderungen übernehmen.';
          const subject = `Neuer Änderungsantrag / HJ2-Freischaltung für Mandant [${firmenname} / ${mandantNr}]`;
          const textBody =
              `Hallo ${coachDetails.name || 'Team'},\n\n` +
              `im Change-Radar liegt ein neuer Antrag bereit.\n\n` +
              `Typ: ${typeLabelDe}\n` +
              `Mandant: ${firmenname}\n` +
              `Mandant-Nummer: ${mandantNr}\n` +
              `Absender: ${senderName} (${storedEmail})\n` +
              `Betreuer: ${coachDetails.name || '—'}\n\n` +
              `Anmerkungen:\n${notes}\n\n` +
              `Bitte im Admin-/Coach-Portal unter Change Radar prüfen.\n`;
          const htmlBody =
              `<p>Hallo ${coachDetails.name || 'Team'},</p>` +
              `<p>im <strong>Change-Radar</strong> liegt ein neuer Antrag bereit.</p>` +
              `<ul>` +
              `<li><strong>Typ:</strong> ${typeLabelDe}</li>` +
              `<li><strong>Mandant:</strong> ${firmenname}</li>` +
              `<li><strong>Mandant-Nummer:</strong> ${mandantNr}</li>` +
              `<li><strong>Absender:</strong> ${senderName} (${storedEmail})</li>` +
              `<li><strong>Betreuer:</strong> ${coachDetails.name || '—'}</li>` +
              `</ul>` +
              `<p><strong>Anmerkungen:</strong><br/>${String(notes).replace(/\n/g, '<br/>')}</p>` +
              `<p>Bitte im Admin-/Coach-Portal unter <em>Change Radar</em> prüfen.</p>`;

          await addDoc(
              collection(db, 'kalkulation_mandanten', clientId, CHANGE_REQUESTS_COLLECTION),
              {
                  clientId,
                  mandantNr,
                  firmenname,
                  betreuer: clientData.betreuer || '',
                  status: 'pending',
                  unlock_h2,
                  type: ticketType,
                  message: notes,
                  senderName,
                  senderEmail: storedEmail,
                  coachName: coachDetails.name || '',
                  coachEmail,
                  createdAt: serverTimestamp(),
              }
          );

          // Backend-Mail: Feld `email` = bestehender processMailQueue-Konvention; `to` = Briefing-Alias
          await addDoc(collection(db, 'mail_queue'), {
              to: coachEmail,
              email: coachEmail,
              type: 'change_request',
              subject,
              text: textBody,
              html: htmlBody,
              message: textBody,
              participantName: senderName,
              salonName: firmenname,
              mandantNr,
              coachName: coachDetails.name || '',
              applicantUid: clientId,
              applicantEmail: storedEmail,
              unlock_h2,
              requestType: ticketType,
              appBaseUrl: typeof window !== 'undefined' ? window.location.origin : '',
              status: 'pending',
              createdAt: serverTimestamp(),
          });
          
          localStorage.removeItem(STORAGE_KEY);
          
          setIsSubmitting(false);
          setShowSuccess(true);
          
          (window as any).isDataSaved = false; 
          document.getElementById('submitBtn')?.classList.add('disabled');
          (window as any).showToast("Antrag gespeichert. Coach wird per E-Mail benachrichtigt.", 'success');
          
          setTimeout(() => window.location.reload(), 2500);
      } catch (err) {
          console.error('change_requests / mail_queue Write fehlgeschlagen:', err);
          setIsSubmitting(false);
          (window as any).showToast("Speicherung/Mail fehlgeschlagen. Bitte erneut versuchen.", 'error');
      }
  };

  useEffect(() => {
      const handleMouseOver = (e: any) => {
          let target = e.target;
          const tooltipNode = target.closest('[data-tooltip]');
          const tooltip = document.getElementById('globalTooltip');
          if (tooltipNode && tooltip) {
              const text = tooltipNode.getAttribute('data-tooltip');
              if (text) {
                  tooltip.innerHTML = text;
                  tooltip.classList.add('visible');
                  const rect = tooltipNode.getBoundingClientRect();
                  let leftPos = rect.left + rect.width / 2 - 100;
                  if (leftPos < 10) leftPos = 10; 
                  tooltip.style.left = leftPos + 'px'; 
                  tooltip.style.top = (rect.top - 45) + 'px'; 
              }
          }
      };
      const handleMouseOut = () => { 
          const t = document.getElementById('globalTooltip'); 
          if(t) t.classList.remove('visible'); 
      };
      document.addEventListener('mouseover', handleMouseOver);
      document.addEventListener('mouseout', handleMouseOut);
      return () => { document.removeEventListener('mouseover', handleMouseOver); document.removeEventListener('mouseout', handleMouseOut); };
  }, []);

  useEffect(() => {
    const currency = settings.country?.currency || 'EUR';
    const sym = currency === 'EUR' ? 'EUR' : 'CHF'; 
    (window as any).APP_CONFIG = { locale: 'de-DE', currency: currency, currencySymbol: sym, defaultHoursPerWeek: 40.00, minWage: settings.country?.Mindestlohn || 13.90, miniJobLimit: settings.country?.Minijob_Lohn_Grenze || 538.00, hasMinWage: true, hasMiniJobRule: true };
    (window as any).fmtEuro = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    (window as any).fmtNum = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    (window as any).getValidDates = function() { const dates = []; for(let i=1; i<=12; i++) { const month = String(i).padStart(2, '0'); dates.push(`01.${month}.`); } return dates; };
    (window as any).generateDateOptions = function() { const dates = (window as any).getValidDates(); let opts = '<option value="" selected>Datum</option>'; dates.forEach(d => opts += `<option value="${d}">${d}</option>`); return opts; };
    (window as any).updateLegalInfoDisplay = function() { 
        const content = [];
        const curSym = (window as any).APP_CONFIG.currencySymbol;
        if ((window as any).APP_CONFIG.hasMinWage) { content.push(`<div class="legal-item inline-block mr-4"><i class="fas fa-scale-balanced mr-1 text-noble-gold"></i> Mindestlohn: <strong class="text-pe-muted dark:text-slate-300 text-lg">${(window as any).fmtEuro.format((window as any).APP_CONFIG.minWage)} ${curSym}</strong></div>`); }
        if ((window as any).APP_CONFIG.hasMiniJobRule) { content.push(`<div class="legal-item inline-block"><i class="fas fa-piggy-bank mr-1 text-noble-gold"></i> Minijob-Grenze: <strong class="text-pe-muted dark:text-slate-300 text-lg">${(window as any).fmtEuro.format((window as any).APP_CONFIG.miniJobLimit)} ${curSym}</strong></div>`); }
        const c1 = document.getElementById('legalInfoExisting'); const c2 = document.getElementById('legalInfoNew');
        if(c1) c1.innerHTML = content.join('<span class="mx-2 text-stone-400 dark:text-slate-600">|</span>'); if(c2) c2.innerHTML = content.join('<span class="mx-2 text-stone-400 dark:text-slate-600">|</span>');
    };
    (window as any).showErrorPopup = showErrorPopup;
    (window as any).closeModal = function(id) { document.getElementById(id).classList.remove('open'); setTimeout(()=>document.getElementById(id).style.display='none',200); };
    (window as any).parseInput = function(val) { if(!val) return 0; let clean = val.toString().replace(/[^0-9,-]/g, '').replace(',', '.'); return parseFloat(clean) || 0; };
    (window as any).formatInput = function(el, unit) { let val = (window as any).parseInput(el.value); if(unit === '€') el.value = (window as any).fmtEuro.format(val); else el.value = (window as any).fmtNum.format(val) + " " + unit; };
    (window as any).formatNumberField = function(el) { let val = (window as any).parseInput(el.value); el.value = (window as any).fmtNum.format(val); };
    (window as any).autoExpand = function(field) { field.style.height = 'inherit'; const h = field.scrollHeight + 2; field.style.height = Math.max(h, 32) + 'px'; };
    (window as any).handleEnter = function(e, el){ if(e.key === 'Enter'){ e.preventDefault(); el.blur(); } };
    (window as any).setGuide = function(el, isActive) { const wrapper = el.closest('.input-wrapper') || el.closest('.table-select'); if(wrapper) { if(isActive) wrapper.classList.add('input-next-step'); else wrapper.classList.remove('input-next-step'); } };
    (window as any).showToast = function(msg, type = 'info') { const toast = document.getElementById('toast'); const msgEl = document.getElementById('toastMsg'); msgEl.textContent = msg; toast.className = 'pe-toast visible ' + type; let toastTimeout; if (toastTimeout) clearTimeout(toastTimeout); toastTimeout = setTimeout(() => { toast.classList.remove('visible'); }, 4000); };
    (window as any).setupSalaryGuard = function() { const tbody = document.getElementById('newStaffBody'); if(!tbody) return; tbody.addEventListener('input', function(e: any) { const t = e.target; if (t.classList.contains('field-base') || t.classList.contains('field-add') || t.classList.contains('field-bonus') || t.classList.contains('field-hours')) { (window as any).salaryChanged = true; } }); };
    
    (window as any).updateLegalInfoDisplay(); (window as any).setupSalaryGuard();
    
    setTimeout(() => {
        const hasExistingDrafts = clientData.drafts?.existingStaff && Object.keys(clientData.drafts.existingStaff).length > 0;
        const newCollapsed = { ...collapsed };
        let stateChanged = false;
        if (hasExistingDrafts && newCollapsed.existing === true) { newCollapsed.existing = false; stateChanged = true; }
        const newStaffDrafts = clientData.drafts?.newStaff || [];
        if (newStaffDrafts.length > 0 && newCollapsed.newStaff === true) { newCollapsed.newStaff = false; stateChanged = true; }
        const entDrafts = clientData.drafts?.entrepreneur || [];
        if (entDrafts.length > 0 && newCollapsed.entrepreneur === true) { newCollapsed.entrepreneur = false; stateChanged = true; }
        const cmDrafts = clientData.drafts?.clientMaster || [];
        if (cmDrafts.length > 0 && newCollapsed.clientData === true) { newCollapsed.clientData = false; stateChanged = true; }
        const costDrafts = clientData.drafts?.costs || [];
        if (costDrafts.length > 0 && newCollapsed.costs === true) { newCollapsed.costs = false; stateChanged = true; }
        const hoursDrafts = clientData.drafts?.openingHours || [];
        if (hoursDrafts.length > 0 && newCollapsed.hours === true) { newCollapsed.hours = false; stateChanged = true; }
        if (stateChanged) setCollapsed(newCollapsed);
    }, 200); 
  }, [clientData, settings]);

  // Seite wieder volle Tabellenbreite + fester Bottom-Scroll steuert #app-main-scroll
  useEffect(() => {
    const main = document.getElementById('app-main-scroll');
    const hScroll = hScrollRef.current;
    const spacer = hSpacerRef.current;
    if (!main || !hScroll || !spacer) return;

    main.classList.add('az-page-hscroll-host');

    const refresh = () => {
      const need = main.scrollWidth > main.clientWidth + 2;
      spacer.style.width = `${Math.max(main.scrollWidth, main.clientWidth)}px`;
      hScroll.style.visibility = need ? 'visible' : 'hidden';
      if (!syncingScrollRef.current) {
        syncingScrollRef.current = true;
        hScroll.scrollLeft = main.scrollLeft;
        syncingScrollRef.current = false;
      }
    };

    const onProxyScroll = () => {
      if (syncingScrollRef.current) return;
      syncingScrollRef.current = true;
      main.scrollLeft = hScroll.scrollLeft;
      syncingScrollRef.current = false;
    };

    const onMainScroll = () => {
      if (syncingScrollRef.current) return;
      syncingScrollRef.current = true;
      hScroll.scrollLeft = main.scrollLeft;
      syncingScrollRef.current = false;
    };

    refresh();
    hScroll.addEventListener('scroll', onProxyScroll, { passive: true });
    main.addEventListener('scroll', onMainScroll, { passive: true });
    window.addEventListener('resize', refresh);

    const ro = new ResizeObserver(refresh);
    ro.observe(main);
    const root = document.getElementById('az-page-root');
    if (root) ro.observe(root);

    const mo = new MutationObserver(refresh);
    if (root) mo.observe(root, { childList: true, subtree: true, attributes: true });

    // Nach Accordion-Open kurz nachmessen
    const t = window.setTimeout(refresh, 50);
    const t2 = window.setTimeout(refresh, 300);

    return () => {
      window.clearTimeout(t);
      window.clearTimeout(t2);
      hScroll.removeEventListener('scroll', onProxyScroll);
      main.removeEventListener('scroll', onMainScroll);
      window.removeEventListener('resize', refresh);
      ro.disconnect();
      mo.disconnect();
      main.classList.remove('az-page-hscroll-host');
    };
  }, [collapsed]);

  return (
    <div id="az-page-root" className="bg-deep-space text-pe-text dark:text-[#e2e8f0] font-sans text-[15px] min-h-screen pt-4 px-4 pb-40">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
      <style>{`
        /* --- PreisExpert NOBLE SLATE DNA (CARBON EDITION) --- */
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700;800&family=Inter:wght@300;400;600;800&display=swap');

        .font-sans { font-family: 'Inter', sans-serif; }
        .font-mono-numbers { font-family: 'JetBrains Mono', monospace; font-variant-numeric: tabular-nums; }

        .bg-deep-space { background-color: #030303; }
        html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
        
        .carbon-weave-bg {
            background-color: #111;
            background-image:
                radial-gradient(circle at 100% 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
                radial-gradient(circle at 0 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
                radial-gradient(circle at 50% 100%, #1a1a1a 10%, #111 10%, #111 23%, #1a1a1a 23%, #1a1a1a 30%, #111 30%, #111 43%, #1a1a1a 43%, #1a1a1a 50%, #111 50%, #111 63%, #1a1a1a 63%, #1a1a1a 71%, transparent 71%, transparent),
                radial-gradient(circle at 100% 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent),
                radial-gradient(circle at 0 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent);
            background-size: 20px 20px;
        }

        .carbon-panel {
            position: relative;
            border-radius: 1.5rem;
            border: 1px solid #1a1a1a;
            box-shadow: 0 30px 60px -15px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.02);
            overflow: visible;
            z-index: 1;
            width: max-content;
            min-width: 100%;
        }

        .carbon-panel::after {
            content: '';
            position: absolute;
            inset: 0;
            background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.55));
            pointer-events: none;
            z-index: 1;
            border-radius: 1.5rem;
        }

        .carbon-content {
            position: relative;
            z-index: 10;
        }

        html.dark body, html.dark { background-color: #030303; }
        #az-page-root { width: max-content; min-width: 100%; }
        #az-page-root main { width: max-content; min-width: 100%; }
        /* Host: App-Main darf horizontal scrollen (nur solange AZ aktiv) */
        #app-main-scroll.az-page-hscroll-host {
            overflow-x: auto !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch;
        }
        ::-webkit-scrollbar { width: 14px; height: 14px; }
        ::-webkit-scrollbar-track { background: #0f172a; }
        ::-webkit-scrollbar-thumb { background: #334155; border-radius: 0; border: 3px solid #0f172a; }
        ::-webkit-scrollbar-thumb:hover { background: #475569; }
        
        .input-wrapper, .result-wrapper, .table-select { position: relative; display: flex; align-items: center; border-radius: 0.25rem; width: 100%; transition: all 0.2s; height: 2.8rem; border: 1px solid #222; font-family: 'JetBrains Mono', monospace; }
        .input-wrapper { background-color: #000000; }
        .input-wrapper:hover, .table-select:hover { border-color: #E6C299; }
        .input-wrapper:focus-within, .table-select:focus { border-color: #E6C299; box-shadow: 0 0 0 1px #E6C299; outline: none; }
        
        .result-wrapper { background-color: rgba(0,0,0,0.4); border-color: #1a1a1a; box-shadow: inset 0 2px 10px rgba(0,0,0,0.5); }
        
        .input-active-look { background-color: #000000 !important; color: white !important; border-color: #94a3b8 !important; cursor: text !important; }
        .input-active-look::placeholder { color: #94a3b8 !important; }
        .opacity-20 { opacity: 0.3 !important; pointer-events: none; }
        .input-next-step { animation: pulse-border 2s infinite; border-color: #ef4444 !important; border-width: 2px !important; box-shadow: 0 0 0 1px #ef4444 !important; }
        .input-error-highlight { border: 3px solid #ef4444 !important; box-shadow: 0 0 10px rgba(239, 68, 68, 0.8) !important; animation: shake 0.4s ease-in-out; }
        @keyframes pulse-border { 0% { border-color: #ef4444; } 50% { border-color: #7f1d1d; } 100% { border-color: #ef4444; } }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .table-input { background-color: transparent; color: #ffffff; font-weight: 700; text-align: center; width: 100%; height: 100%; border: none; outline: none; font-size: 1rem; font-family: 'JetBrains Mono', monospace; padding: 0; margin: 0; padding-right: 2.5rem; }
        .table-input:disabled { color: #475569; cursor: not-allowed; font-weight: 600; }
        .table-input.ghost-value, .table-select.ghost-value { color: #475569 !important; }
        .table-input.active-value { color: #ffffff !important; }
        .table-select { -webkit-appearance: none !important; -moz-appearance: none !important; appearance: none !important; background-color: #000000 !important; color: #E6C299 !important; font-family: 'JetBrains Mono', monospace !important; font-size: 1rem !important; font-weight: 700 !important; text-align: center !important; text-align-last: center !important; border: 1px solid #222 !important; border-radius: 0.25rem !important; padding: 0 2.5rem 0 0.5rem !important; width: 100%; height: 2.8rem !important; line-height: 2.8rem !important; cursor: pointer; background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23E6C299' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e") !important; background-repeat: no-repeat !important; background-position: right 0.5rem center !important; background-size: 1em !important; }
        .table-select:focus { outline: none !important; border-color: #E6C299 !important; box-shadow: 0 0 0 1px #E6C299 !important; }
        .table-select:disabled { background-color: transparent !important; color: #475569 !important; border-color: transparent !important; cursor: not-allowed !important; background-image: none !important; }
        .table-select option { background-color: #111; color: white; padding: 8px; }
        .unit-label { position: absolute; right: 0.75rem; top: 0; bottom: 0; display: flex; align-items: center; pointer-events: none; }
        .unit-text { color: #64748b; font-weight: 700; font-size: 0.75rem; letter-spacing: 0.05em; text-transform: uppercase; font-family: 'Inter', sans-serif; }
        .table-calc { background-color: transparent; color: #E6C299; border: none; font-weight: 700; display: flex; align-items: center; justify-content: center; height: 100%; font-size: 1rem; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-family: 'JetBrains Mono', monospace; padding-right: 2.5rem; }
        
        .table-textarea { background-color: #000000; color: #ffffff; width: 100%; border: 1px solid #222; outline: none; border-radius: 0.25rem; resize: none; overflow: hidden; min-height: 2.8rem; line-height: 1.4; padding-top: 0.6rem; text-align: left; padding-left: 0.75rem; font-family: 'Inter', sans-serif; font-size: 0.9rem; transition: border-color 0.2s; }
        .table-textarea:focus { border-color: #E6C299; }
        .table-container-full { width: max-content; min-width: 100%; padding-left: 1.5rem; padding-right: 1.5rem; }
        /* Tabellen wieder volle natürliche Breite — kein Einklemmen */
        #az-page-root .table-wrapper {
            width: max-content !important;
            min-width: 100% !important;
            max-width: none !important;
            overflow: visible !important;
            border-radius: 0.375rem;
            background-color: transparent;
            margin-bottom: 0.5rem;
            display: block;
        }
        #az-page-root table {
            width: max-content !important;
            min-width: 100% !important;
            border-collapse: collapse;
            border-spacing: 0;
            table-layout: auto;
        }

        .az-fixed-hscroll {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 4.25rem;
            z-index: 55;
            height: 20px;
            padding-left: 6rem;
            padding-right: 1rem;
            background: rgba(3, 3, 3, 0.98);
            border-top: 1px solid #333;
            overflow-x: scroll;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
        }
        @media (max-width: 767px) {
            .az-fixed-hscroll { padding-left: 1rem; bottom: 5.5rem; }
        }
        .az-fixed-hscroll::-webkit-scrollbar { height: 16px; }
        .az-fixed-hscroll::-webkit-scrollbar-track { background: #0f172a; }
        .az-fixed-hscroll::-webkit-scrollbar-thumb { background: #E6C299; border-radius: 4px; border: 2px solid #0f172a; }
        .az-fixed-hscroll::-webkit-scrollbar-thumb:hover { background: #f0d4b0; }
        
        .pe-table-header th { background-color: rgba(0,0,0,0.5); color: #E6C299; font-size: 0.85rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; text-align: center; border-bottom: 1px solid #222; padding: 1.2rem 1rem; white-space: nowrap; font-family: 'Inter', sans-serif; border-left: none; border-right: none; }
        .pe-row { background-color: transparent; }
        .pe-row td { border-bottom: 1px solid #1a1a1a; border-top: 1px solid #1a1a1a; border-left: none; border-right: none; padding: 0.75rem 1rem; vertical-align: middle; white-space: nowrap; }
        .pe-row:hover td { background-color: rgba(255,255,255,0.02); }
        
        .col-tight { width: 1px; white-space: nowrap; }
        .col-expand { width: auto; min-width: 420px; white-space: normal !important; }
        .col-expand textarea { min-width: 100%; }
        
        .locked-row .input-wrapper, .locked-row .table-select { background-color: rgba(2, 44, 34, 0.3) !important; border-color: #064e3b !important; }
        .locked-row .result-wrapper { background-color: transparent !important; border-color: transparent !important; }
        .locked-row .table-input, .locked-row .table-select { color: #6ee7b7 !important; cursor: not-allowed !important; pointer-events: none; }
        .locked-row .table-calc { color: #6ee7b7 !important; }
        .locked-row .unit-text { color: #047857 !important; }
        
        .hr-title { font-size: 0.9rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; color: #E6C299; margin-bottom: 1.25rem; padding-bottom: 0.5rem; border-bottom: 1px solid rgba(230, 194, 153, 0.2); font-family: 'Inter', sans-serif; }
        .hr-label { font-size: 0.75rem; color: #94a3b8; text-transform: uppercase; font-weight: 700; margin-bottom: 0.35rem; display: block; font-family: 'Inter', sans-serif; }
        .info-box { background-color: rgba(0, 0, 0, 0.4); border-left: 2px solid #E6C299; color: #e2e8f0; padding: 0.75rem 1.25rem; display: flex; align-items: center; gap: 0.75rem; font-size: 0.9rem; border-radius: 0 0.25rem 0.25rem 0; width: fit-content; margin-bottom: 0.5rem; border-top: 1px solid #1a1a1a; border-right: 1px solid #1a1a1a; border-bottom: 1px solid #1a1a1a; }
        
        /* NOBLE SLATE ACCORDION HEADER ADAPTATION */
        .pe-accordion-header { width: 100%; background-color: transparent; border-bottom: 1px solid rgba(255,255,255,0.05); padding: 1.5rem 2rem; display: flex; justify-content: flex-start; align-items: center; cursor: pointer; transition: all 0.2s; gap: 1rem; }
        .pe-accordion-header:hover { background-color: rgba(255,255,255,0.02); }
        .pe-accordion-title { font-size: 1.1rem; font-weight: 800; color: #f1f5f9; text-transform: uppercase; letter-spacing: 0.05em; display: flex; align-items: center; gap: 0.75rem; font-family: 'Inter', sans-serif; }
        .pe-helper-text { font-size: 0.75rem; color: #64748b; font-weight: normal; font-style: italic; margin-left: 0.5rem; font-family: 'Inter', sans-serif; }
        .section-toggle-icon { transition: transform 0.3s ease; color: #E6C299; }
        .section-toggle-icon.open { transform: rotate(180deg); }
        
        .btn-add-row { color: #E6C299; font-weight: 700; font-size: 0.85rem; text-transform: uppercase; display: flex; align-items: center; gap: 0.5rem; margin-top: 0.75rem; padding: 0.5rem 1.25rem; border: 1px dashed #E6C299; border-radius: 0.375rem; width: max-content; transition: all 0.2s; cursor: pointer; font-family: 'Inter', sans-serif; }
        .btn-add-row:hover { background-color: rgba(230, 194, 153, 0.1); color: white; border-color: white; }
        .btn-admin-lock { background-color: rgba(0,0,0,0.5); color: #64748b; border: 1px solid #222; width: 100%; height: 2.8rem; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; border-radius: 0.25rem; font-size: 0.9rem; }
        .btn-admin-lock:hover { background-color: rgba(255,255,255,0.05); color: #E6C299; border-color: #E6C299; }
        .admin-badge { background-color: rgba(6, 78, 59, 0.9); border: 1px solid #10b981; color: #d1fae5; font-size: 0.6rem; padding: 0.1rem 0.4rem; border-radius: 0.25rem; display: flex; flex-direction: column; align-items: center; line-height: 1; white-space: nowrap; cursor: pointer; transition: all 0.2s; min-width: 40px; }
        .status-container { height: 2.8rem; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.85rem; border-radius: 0.25rem; cursor: default; width: 100%; text-transform: uppercase; border: 1px solid transparent; font-family: 'Inter', sans-serif; }
        .status-ok { color: #4ade80; background-color: rgba(74, 222, 128, 0.1); border-color: rgba(74, 222, 128, 0.2); }
        .status-warn { background-color: rgba(220, 38, 38, 0.2); color: #f87171; border-color: rgba(220, 38, 38, 0.4); animation: pulse-red-text 2s infinite; }
        .status-neutral { color: #64748b; font-family: 'JetBrains Mono', monospace; font-size: 1.2rem; }
        
        @keyframes pulse-red-text { 0% { opacity: 1; } 50% { opacity: 0.7; } 100% { opacity: 1; } }
        
        .pe-toast { position: fixed; bottom: 50px; left: 50%; transform: translateX(-50%) translateY(20px); background-color: #111; border: 1px solid; padding: 1rem 2rem; border-radius: 0.5rem; box-shadow: 0 10px 30px rgba(0,0,0,0.9); z-index: 6000; font-size: 0.9rem; opacity: 0; pointer-events: none; transition: all 0.3s; display: flex; align-items: center; gap: 1rem; font-weight: 700; }
        .pe-toast.visible { opacity: 1; transform: translateX(-50%) translateY(0); pointer-events: auto; }
        .pe-toast.error { border-color: #ef4444; color: #fca5a5; background-color: rgba(69, 10, 10, 0.95); }
        .pe-toast.info { border-color: #E6C299; color: #E6C299; background-color: #111; }
        .pe-toast.success { border-color: #22c55e; color: #bbf7d0; background-color: rgba(20, 83, 45, 0.95); }
        
        .floating-action-bar { position: fixed; bottom: 0; left: 0; width: 100%; background-color: rgba(3, 3, 3, 0.95); border-top: 1px solid #1a1a1a; padding: 1rem 1.5rem; padding-left: 6rem; display: flex; justify-content: flex-start; gap: 1.5rem; z-index: 50; backdrop-filter: blur(4px); }
        .fab-btn { padding: 0.5rem 2rem; border-radius: 0.375rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; transition: all 0.2s; display: flex; align-items: center; gap: 0.5rem; font-size: 0.9rem; font-family: 'Inter', sans-serif; }
        .btn-clean { background-color: #111; color: #E6C299; border: 1px solid #E6C299; } .btn-clean:hover { background-color: #E6C299; color: black; }
        .btn-submit { background-color: #E6C299; color: black; border: 1px solid #E6C299; } .btn-submit:hover { background-color: white; transform: translateY(-2px); }
        .btn-submit.disabled { background-color: transparent; color: #475569; border-color: #222; box-shadow: none; cursor: not-allowed; transform: none; }
        .reset-btn-row { background: transparent; border: none; cursor: pointer; padding: 4px; transition: color 0.2s; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; }
        .reset-btn-row:hover i { color: #E6C299 !important; }
        
        .modal-backdrop { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.85); display: none; align-items: center; justify-content: center; z-index: 999999; backdrop-filter: blur(4px); }
        .modal-backdrop.open { display: flex; }
        .modal-box { background-color: #111; border: 1px solid #E6C299; border-radius: 0.75rem; padding: 1.5rem; max-width: 450px; width: 90%; text-align: center; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.9); }
        .modal-title { font-size: 1.25rem; font-weight: 800; color: #E6C299; margin-bottom: 1rem; text-transform: uppercase; font-family: 'Inter', sans-serif; }
        .modal-text { color: #cbd5e1; margin-bottom: 1.5rem; font-size: 0.95rem; line-height: 1.5; font-family: 'Inter', sans-serif; }
        .modal-btn { padding: 0.6rem 1.2rem; border-radius: 0.375rem; font-weight: 700; text-transform: uppercase; transition: all 0.2s; cursor: pointer; width: 100%; font-size: 0.9rem; font-family: 'Inter', sans-serif; }
        .modal-btn-cancel { background-color: transparent; color: white; border: 1px solid #222; } .modal-btn-cancel:hover { background-color: #222; }
        .modal-btn-confirm { background-color: #E6C299; color: black; border: 1px solid #E6C299; } .modal-btn-confirm:hover { background-color: white; }
        .modal-btn-warn { background-color: #7f1d1d; color: #fca5a5; border: 1px solid #ef4444; } .modal-btn-warn:hover { background-color: #ef4444; color: white; }
        
        .pe-tooltip { background-color: #E6C299; color: black; border: 1px solid white; font-weight: 700; border-radius: 0.25rem; padding: 0.5rem; position: fixed; z-index: 2147483647; display: none; font-size: 0.8rem; max-width: 250px; box-shadow: 0 10px 20px rgba(0,0,0,0.6); pointer-events: none; font-family: 'Inter', sans-serif; }
        .pe-tooltip.visible { display: block; }
        
        .pwd-input { background-color: black; color: white; border: 2px solid #222; font-size: 1.5rem; text-align: center; padding: 0.5rem; border-radius: 0.5rem; width: 100%; margin-bottom: 1.5rem; font-weight: 800; letter-spacing: 0.2em; outline: none; font-family: 'JetBrains Mono', monospace; }
        .pwd-input:focus { border-color: #E6C299; }
        .admin-select { background-color: black; color: #E6C299; font-size: 1rem; padding: 0.5rem; border-radius: 0.5rem; width: 100%; margin-bottom: 1.5rem; border: 1px solid #E6C299; font-family: 'Inter', sans-serif; }
        .hidden-col { display: none !important; }
        .text-noble-gold { color: #E6C299; }
        
        .send-input { width: 100%; background-color: #000; border: 1px solid #222; color: white; padding: 0.6rem; border-radius: 0.25rem; outline: none; transition: border-color 0.2s; font-family: 'Inter', sans-serif; }
        .send-input:focus { border-color: #E6C299; }
        .send-input.error { border-color: #ef4444; background-color: rgba(69, 10, 10, 0.3); }
        .send-label { font-size: 0.75rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; margin-bottom: 0.3rem; display: block; text-align: left; font-family: 'Inter', sans-serif; }
        .send-textarea { min-height: 100px; resize: none; }
        .modal-readonly { background-color: transparent; color: #cbd5e1; cursor: default; border: 1px dashed #222; padding: 0.5rem; border-radius: 0.25rem; text-align: left; font-family: 'Inter', sans-serif; }

        /* ============================================================
           LIGHT-MODE OVERRIDES (Ring 4a) — Dark Mode bleibt pixelidentisch,
           da alle Regeln nur unter html:not(.dark) greifen.
           ============================================================ */
        html:not(.dark), html:not(.dark) body { background-color: var(--pe-bg-primary); }
        html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
        html:not(.dark) .carbon-weave-bg { background-color: var(--pe-bg-elevated); background-image: none; }
        html:not(.dark) .carbon-panel { background-color: var(--pe-bg-card); border-color: var(--pe-border-subtle); box-shadow: 0 10px 30px -12px rgba(28,25,23,0.15); }
        html:not(.dark) .carbon-panel::after { background: none; }
        html:not(.dark) .carbon-panel::after { background: none; }
        html:not(.dark) ::-webkit-scrollbar-track { background: #EAE7E2; }
        html:not(.dark) ::-webkit-scrollbar-thumb { background: #B8B2AC; border: 3px solid #EAE7E2; }
        html:not(.dark) ::-webkit-scrollbar-thumb:hover { background: #8D8781; }
        html:not(.dark) .input-wrapper, html:not(.dark) .result-wrapper { border-color: #B8B2AC; }
        html:not(.dark) .input-wrapper { background-color: var(--pe-bg-input); }
        html:not(.dark) .input-wrapper:hover, html:not(.dark) .table-select:hover { border-color: #8D6435; }
        html:not(.dark) .input-wrapper:focus-within, html:not(.dark) .table-select:focus { border-color: #8D6435; box-shadow: 0 0 0 1px #8D6435; }
        html:not(.dark) .result-wrapper { background-color: rgba(28,25,23,0.04); border-color: #D6D3D1; box-shadow: inset 0 1px 4px rgba(28,25,23,0.08); }
        html:not(.dark) .input-active-look { background-color: var(--pe-bg-input) !important; color: #1C1917 !important; border-color: #78716C !important; }
        html:not(.dark) .input-active-look::placeholder { color: #A8A29E !important; }
        html:not(.dark) .table-input { color: #1C1917; }
        html:not(.dark) .table-input:disabled { color: #A8A29E; }
        html:not(.dark) .table-input.ghost-value, html:not(.dark) .table-select.ghost-value { color: #A8A29E !important; }
        html:not(.dark) .table-input.active-value { color: #1C1917 !important; }
        html:not(.dark) .table-select { background-color: var(--pe-bg-input) !important; color: #8D6435 !important; border: 1px solid #B8B2AC !important; background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%238D6435' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e") !important; }
        html:not(.dark) .table-select:focus { border-color: #8D6435 !important; box-shadow: 0 0 0 1px #8D6435 !important; }
        html:not(.dark) .table-select:disabled { background-color: transparent !important; color: #A8A29E !important; border-color: transparent !important; }
        html:not(.dark) .table-select option { background-color: var(--pe-bg-input); color: #1C1917; }
        html:not(.dark) .unit-text { color: #78716C; }
        html:not(.dark) .table-calc { color: #8D6435; }
        html:not(.dark) .table-textarea { background-color: var(--pe-bg-input); color: #1C1917; border-color: #B8B2AC; }
        html:not(.dark) .table-textarea:focus { border-color: #8D6435; }
        html:not(.dark) .az-fixed-hscroll { background: var(--pe-bg-primary); border-top: 1px solid #D6D3D1; }
        html:not(.dark) .az-fixed-hscroll::-webkit-scrollbar-track { background: #EAE7E2; }
        html:not(.dark) .az-fixed-hscroll::-webkit-scrollbar-thumb { background: #8D6435; border: 2px solid #EAE7E2; }
        html:not(.dark) .az-fixed-hscroll::-webkit-scrollbar-thumb:hover { background: #6d4c28; }
        html:not(.dark) .pe-table-header th { background-color: rgba(28,25,23,0.05); color: #8D6435; border-bottom: 1px solid #D6D3D1; }
        html:not(.dark) .pe-row td { border-bottom: 1px solid #E7E5E4; border-top: 1px solid #E7E5E4; }
        html:not(.dark) .pe-row:hover td { background-color: rgba(28,25,23,0.03); }
        html:not(.dark) .locked-row .input-wrapper, html:not(.dark) .locked-row .table-select { background-color: rgba(16, 185, 129, 0.08) !important; border-color: #6ee7b7 !important; }
        html:not(.dark) .locked-row .table-input, html:not(.dark) .locked-row .table-select { color: #047857 !important; }
        html:not(.dark) .locked-row .table-calc { color: #047857 !important; }
        html:not(.dark) .locked-row .unit-text { color: #059669 !important; }
        html:not(.dark) .hr-title { color: #8D6435; border-bottom-color: rgba(141, 100, 53, 0.25); }
        html:not(.dark) .hr-label { color: #57534E; }
        html:not(.dark) .info-box { background-color: var(--pe-bg-card); border-left-color: #8D6435; color: #44403C; border-top-color: #E7E5E4; border-right-color: #E7E5E4; border-bottom-color: #E7E5E4; }
        html:not(.dark) .pe-accordion-header { border-bottom-color: rgba(28,25,23,0.08); }
        html:not(.dark) .pe-accordion-header:hover { background-color: rgba(28,25,23,0.03); }
        html:not(.dark) .pe-accordion-title { color: #1C1917; }
        html:not(.dark) .pe-helper-text { color: #78716C; }
        html:not(.dark) .section-toggle-icon { color: #8D6435; }
        html:not(.dark) .btn-add-row { color: #8D6435; border-color: #8D6435; }
        html:not(.dark) .btn-add-row:hover { background-color: rgba(141, 100, 53, 0.1); color: #1C1917; border-color: #1C1917; }
        html:not(.dark) .btn-admin-lock { background-color: rgba(28,25,23,0.04); color: #78716C; border-color: #D6D3D1; }
        html:not(.dark) .btn-admin-lock:hover { background-color: rgba(28,25,23,0.08); color: #8D6435; border-color: #8D6435; }
        html:not(.dark) .status-ok { color: #047857; background-color: rgba(4, 120, 87, 0.08); border-color: rgba(4, 120, 87, 0.25); }
        html:not(.dark) .status-warn { background-color: rgba(220, 38, 38, 0.08); color: #B91C1C; border-color: rgba(220, 38, 38, 0.35); }
        html:not(.dark) .status-neutral { color: #78716C; }
        html:not(.dark) .pe-toast { background-color: var(--pe-bg-card); box-shadow: 0 10px 30px rgba(28,25,23,0.25); }
        html:not(.dark) .pe-toast.error { color: #B91C1C; background-color: rgba(254, 226, 226, 0.97); }
        html:not(.dark) .pe-toast.info { color: #8D6435; background-color: var(--pe-bg-card); border-color: #8D6435; }
        html:not(.dark) .pe-toast.success { color: #047857; background-color: rgba(209, 250, 229, 0.97); }
        html:not(.dark) .floating-action-bar { background-color: var(--pe-bg-primary); border-top: 1px solid #D6D3D1; }
        html:not(.dark) .btn-clean { background-color: var(--pe-bg-card); color: #8D6435; border-color: #8D6435; }
        html:not(.dark) .btn-clean:hover { background-color: #8D6435; color: #FFFFFF; }
        html:not(.dark) .btn-submit.disabled { color: #A8A29E; border-color: #D6D3D1; }
        html:not(.dark) .modal-backdrop { background-color: rgba(28, 25, 23, 0.5); }
        html:not(.dark) .modal-box { background-color: var(--pe-bg-card); border-color: #8D6435; box-shadow: 0 25px 50px -12px rgba(28, 25, 23, 0.35); }
        html:not(.dark) .modal-title { color: #8D6435; }
        html:not(.dark) .modal-text { color: #44403C; }
        html:not(.dark) .modal-btn-cancel { color: #1C1917; border-color: #D6D3D1; }
        html:not(.dark) .modal-btn-cancel:hover { background-color: #EDEAE6; }
        html:not(.dark) .modal-btn-warn { background-color: #FEE2E2; color: #B91C1C; }
        html:not(.dark) .pe-tooltip { border-color: #8D6435; }
        html:not(.dark) .pwd-input { background-color: var(--pe-bg-input); color: #1C1917; border-color: #D6D3D1; }
        html:not(.dark) .pwd-input:focus { border-color: #8D6435; }
        html:not(.dark) .admin-select { background-color: var(--pe-bg-input); color: #8D6435; border-color: #8D6435; }
        html:not(.dark) .text-noble-gold { color: #8D6435; }
        html:not(.dark) .send-input { background-color: var(--pe-bg-input); border-color: #B8B2AC; color: #1C1917; }
        html:not(.dark) .send-input:focus { border-color: #8D6435; }
        html:not(.dark) .send-input.error { border-color: #ef4444; background-color: rgba(254, 226, 226, 0.5); }
        html:not(.dark) .send-label { color: #57534E; }
        html:not(.dark) .modal-readonly { color: #44403C; border-color: #D6D3D1; }
      `}</style>

      <div id="globalTooltip" className="pe-tooltip" style={{ display: 'none' }}></div>
      <div id="toast" className="pe-toast" style={{ display: 'none' }}><i className="fas fa-exclamation-circle text-2xl"></i><span id="toastMsg">Nachricht</span></div>

      {/* --- ERROR MODAL --- */}
      <div id="errorModal" className="modal-backdrop" style={{ display: 'none' }}>
          <div className="modal-box border-red-500">
              <div className="modal-title text-red-600 dark:text-red-500" id="errorModalTitle">STOPP!</div>
              <div className="modal-text" id="errorModalText">Fehlerbeschreibung</div>
              <div className="modal-actions">
                  <button className="modal-btn modal-btn-warn w-full" onClick={() => (window as any).closeModal('errorModal')}>
                      Verstanden, ich korrigiere das.
                  </button>
              </div>
          </div>
      </div>

      {/* --- ADMIN LOCK MODAL --- */}
      <div className={`modal-backdrop ${lockModalOpen ? 'open' : ''}`} style={{ display: lockModalOpen ? 'flex' : 'none' }}>
          <div className="modal-box max-w-[400px]">
              <div className="modal-title flex items-center justify-center gap-2">
                  <i className="fas fa-lock text-pe-accent-text dark:text-[#E6C299]"></i>
                  <span>Admin Bereich</span>
              </div>

              {lockStep === 1 && (
                  <div id="adminStep1">
                      <p className="text-pe-muted dark:text-slate-400 mb-4 text-sm">Bitte Admin-Passwort eingeben</p>
                      <input 
                          type="password" 
                          id="adminPwdInput" 
                          className="pwd-input" 
                          placeholder="****" 
                          maxLength={4} 
                          value={adminPwd}
                          onChange={(e) => setAdminPwd(e.target.value)}
                          onKeyDown={(e) => e.key === 'Enter' && processAdminStep1()}
                      />
                      <div className="modal-actions flex gap-2">
                          <button className="modal-btn modal-btn-cancel" onClick={() => setLockModalOpen(false)}>Abbrechen</button>
                          <button className="modal-btn modal-btn-confirm" onClick={processAdminStep1}>Weiter</button>
                      </div>
                  </div>
              )}

              {lockStep === 2 && (
                  <div id="adminStep2">
                      <p className="text-pe-muted dark:text-slate-300 mb-2 font-bold text-lg">Zeile sperren</p>
                      <p className="text-pe-muted dark:text-slate-400 mb-4 text-sm">Wer hat diese Änderung geprüft?</p>
                      <select 
                          className="admin-select"
                          value={selectedCoach}
                          onChange={(e) => setSelectedCoach(e.target.value)}
                      >
                          <option value="" disabled>Betreuer wählen</option>
                          {ADMIN_USERS.map(u => <option key={u} value={u}>{u}</option>)}
                      </select>
                      <div className="modal-actions flex gap-2">
                          <button className="modal-btn modal-btn-cancel" onClick={() => setLockModalOpen(false)}>Abbrechen</button>
                          <button className="modal-btn modal-btn-confirm" onClick={processLocking}>Jetzt Sperren</button>
                      </div>
                  </div>
              )}

              {lockStep === 3 && (
                  <div id="adminStep3">
                      <p className="mb-2 font-bold text-lg text-red-600 dark:text-red-400">Zeile entsperren?</p>
                      <p className="text-pe-muted dark:text-slate-400 mb-6 text-sm">Warnung: Die Werte können danach wieder vom User verändert werden.</p>
                      <div className="modal-actions flex gap-2">
                          <button className="modal-btn modal-btn-cancel" onClick={() => setLockModalOpen(false)}>Abbrechen</button>
                          <button className="modal-btn modal-btn-warn" onClick={processUnlocking}>Entsperren</button>
                      </div>
                  </div>
              )}
          </div>
      </div>

      {/* --- SEND MODAL --- */}
      <div className={`modal-backdrop ${showSendModal ? 'open' : ''}`} style={{ display: showSendModal ? 'flex' : 'none' }}>
          <div className="modal-box w-full max-w-[500px]">
              <div className="modal-title flex items-center justify-center gap-2">
                  <i className="fas fa-paper-plane text-pe-accent-text dark:text-[#E6C299]"></i> 
                  <span>Änderungen senden</span>
              </div>
              
              <div className="text-left space-y-4 mb-6">
                  <div className="bg-pe-tile-header dark:bg-[#000] p-3 rounded border border-pe-border dark:border-[#222]">
                      <span className="send-label">Betreuer / Empfänger</span>
                      <div className="text-pe-text dark:text-white font-bold flex flex-col gap-1">
                          <div className="flex items-center gap-2">
                              <i className="fas fa-user-tie text-blue-700 dark:text-blue-400"></i>
                              {getCoachDetails().name} 
                          </div>
                          <span className="text-xs font-normal text-stone-500 dark:text-gray-500 ml-6">
                              {getCoachDetails().email}
                          </span>
                      </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                      <div>
                          <span className="send-label">Mandant-Nummer</span>
                          <input type="text" className="send-input !bg-stone-100 dark:!bg-[#111] !text-stone-500 dark:!text-gray-500 cursor-not-allowed" value={clientData.mandantNr || ''} disabled />
                      </div>
                      <div>
                          <span className="send-label">Name (aus Akte)</span>
                          <input 
                              type="text" 
                              className="send-input !bg-stone-100 dark:!bg-[#111] !text-stone-500 dark:!text-gray-500 cursor-not-allowed" 
                              value={clientData.unternehmername || sendForm.name || ''} 
                              disabled
                              readOnly
                              placeholder="Kein Name hinterlegt"
                          />
                      </div>
                  </div>

                  <div>
                      <span className="send-label">E-Mail (aus Akte)</span>
                      <input 
                          type="email" 
                          className={`send-input !bg-stone-100 dark:!bg-[#111] !text-stone-500 dark:!text-gray-500 cursor-not-allowed ${emailError ? 'error' : ''}`} 
                          value={clientData.mailadresse || ''} 
                          disabled
                          readOnly
                          placeholder="Keine E-Mail hinterlegt"
                      />
                  </div>

                  <div>
                      <span className="send-label">Nachricht an Betreuer</span>
                      <textarea 
                          className="send-input send-textarea" 
                          value={sendForm.message} 
                          onChange={(e) => setSendForm({...sendForm, message: e.target.value})} 
                          placeholder="Hallo, hier sind meine Änderungen..."
                      ></textarea>
                  </div>

                  {/* Checkbox: Freischaltung 2. Halbjahr → Firestore unlock_h2 */}
                  <div 
                      className="mt-4 bg-pe-card dark:bg-[#111] border border-pe-border dark:border-[#222] rounded-md p-4 flex items-start gap-3 cursor-pointer hover:border-[#8D6435] dark:hover:border-[#E6C299] transition-colors" 
                      onClick={() => setRequestSecondHalf(!requestSecondHalf)}
                      role="checkbox"
                      aria-checked={requestSecondHalf}
                      aria-label="Freischaltung für das 2. Halbjahr beantragen"
                  >
                      <div className={`mt-0.5 flex items-center justify-center min-w-[20px] w-5 h-5 rounded border transition-all ${requestSecondHalf ? 'bg-[#E6C299] border-[#E6C299] text-black' : 'border-pe-border-strong dark:border-[#444] bg-pe-input dark:bg-black'}`}>
                          {requestSecondHalf && <i className="fas fa-check text-xs"></i>}
                      </div>
                      <div>
                          <div className={`font-bold text-sm ${requestSecondHalf ? 'text-pe-accent-text dark:text-[#E6C299]' : 'text-pe-muted dark:text-slate-300'}`}>
                              <i className="fas fa-unlock-keyhole mr-2"></i>Freischaltung für das 2. Halbjahr beantragen
                          </div>
                          <div className="text-xs text-stone-500 dark:text-slate-500 mt-1 leading-relaxed">
                              Setze diesen Haken, wenn dein Betreuer das zweite Halbjahr für dich prüfen und freischalten soll.
                          </div>
                      </div>
                  </div>

              </div>

              <div className="modal-actions flex gap-2">
                  <button className="modal-btn modal-btn-cancel" onClick={() => setShowSendModal(false)}>Abbrechen</button>
                  <button 
                      className={`modal-btn modal-btn-confirm flex items-center justify-center gap-2 ${(emailError || isSubmitting || showSuccess) ? 'opacity-50 cursor-not-allowed' : ''}`} 
                      onClick={executeSend}
                      disabled={emailError || isSubmitting || showSuccess}
                  >
                      {isSubmitting ? (
                          <><i className="fas fa-spinner fa-spin"></i><span>Verarbeite...</span></>
                      ) : showSuccess ? (
                          <><i className="fas fa-check"></i><span>Erfolg!</span></>
                      ) : (
                          <><span>Jetzt Absenden</span><i className="fas fa-arrow-right"></i></>
                      )}
                  </button>
              </div>
          </div>
      </div>

      <div id="salaryCheckModal" className="modal-backdrop" style={{ display: 'none' }}><div className="modal-box"><div className="modal-title text-orange-700 dark:text-orange-500"><i className="fas fa-exclamation-triangle"></i> Lohnänderung erkannt</div><p className="modal-text">Du hast Lohnwerte geändert!<br />Hast du geprüft, ob auch <strong>Zulagen, Boni oder Stunden</strong> angepasst werden müssen?</p><div className="modal-actions flex gap-2"><button className="modal-btn modal-btn-cancel" onClick={() => (window as any).closeModal('salaryCheckModal')}>Nein, prüfen</button><button className="modal-btn modal-btn-warn" onClick={() => (window as any).confirmSalaryCheck()}>Ja, habe ich geprüft</button></div></div></div>

      <main className="w-full">
        {/* SECTION A: RECHNER */}
        <div className="w-full max-w-none mx-0 px-4 border-b border-pe-border dark:border-[#1a1a1a] pb-8 mb-8 text-center">
            {/* RECHNER STATIC OPEN */}
            <div className="w-full flex flex-col md:flex-row gap-6 justify-start items-start pl-[2rem] mt-4">
                
                <div className="flex flex-col w-full md:w-auto min-w-[280px]">
                    <div className="carbon-panel w-full bg-pe-card dark:bg-[#030303]">
                        <div className="carbon-content p-6">
                            <h3 className="hr-title carbon-weave-bg px-3 py-2 rounded-lg -mx-1 mb-4">Ø-Rechner</h3>
                            <div className="grid grid-cols-2 gap-4 mb-2">
                                <div className="relative">
                                    <label className="hr-label">Std./Tag</label>
                                    <div className="input-wrapper"><input type="text" id="dr_stunden" className="table-input" defaultValue="6,00" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcDurchschnitt()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">Std.</span></div></div>
                                </div>
                                <div className="relative">
                                    <label className="hr-label">Tage/Mo</label>
                                    <div className="input-wrapper"><input type="text" id="dr_tage" className="table-input" defaultValue="2,00" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcDurchschnitt()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">T.</span></div></div>
                                </div>
                            </div>
                            <div className="flex justify-between items-center relative h-[2.8rem] mt-6">
                                <span className="text-xs text-pe-muted dark:text-slate-400 font-bold uppercase mr-2 font-sans tracking-wider">Ø Woche:</span>
                                <div className="result-wrapper flex-grow"><div id="dr_result" className="table-calc">2,77</div><div className="unit-label"><span className="unit-text">Std.</span></div></div>
                            </div>
                        </div>
                    </div>
                    
                    <button 
                        onClick={(e) => {
                            e.preventDefault();
                            if (navigateTo) {
                                navigateTo('datenuebersicht');
                                setTimeout(() => {
                                    document.getElementById('provision-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }, 300);
                            } else {
                                console.error("Router Prop 'navigateTo' fehlt. Button funktioniert hier nicht.");
                            }
                        }}
                        className="w-full bg-blue-100/70 dark:bg-blue-950/30 hover:bg-blue-200 dark:hover:bg-blue-900 text-blue-800 dark:text-blue-400 hover:text-blue-900 dark:hover:text-white font-bold py-3 px-6 rounded-xl transition-all flex items-center justify-center gap-3 border border-blue-300 dark:border-blue-500/30 shadow-lg mt-4 font-sans tracking-wide"
                        data-tooltip-id="app-tooltip"
                        data-tooltip-content="Hier kannst du die Provisionen in der Datenübersicht anpassen."
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="5" x2="5" y2="19"></line>
                            <circle cx="6.5" cy="6.5" r="2.5"></circle>
                            <circle cx="17.5" cy="17.5" r="2.5"></circle>
                        </svg>
                        Zu den Provisionen springen
                    </button>

                    <button
                        type="button"
                        onClick={() => setBonusModalOpen(true)}
                        className="w-full bg-amber-100/70 dark:bg-amber-950/30 hover:bg-amber-200 dark:hover:bg-amber-900/50 text-amber-900 dark:text-amber-300 hover:text-amber-950 dark:hover:text-amber-100 font-bold py-3 px-6 rounded-xl transition-all flex items-center justify-center gap-3 border border-amber-400/40 dark:border-amber-500/30 shadow-lg mt-3 font-sans tracking-wide"
                        data-tooltip-id="app-tooltip"
                        data-tooltip-content="Anstehende Einzel- oder Team-Boni je Mitarbeiter (1. + 2. Halbjahr)."
                    >
                        <i className="fas fa-gift"></i>
                        Anstehende Boni anzeigen
                    </button>
                </div>

                {/* Rechner 2 */}
                <div className="carbon-panel !w-auto !min-w-[320px] !max-w-[600px] bg-pe-card dark:bg-[#030303]">
                    <div className="carbon-content p-6">
                        <h3 className="hr-title carbon-weave-bg px-3 py-2 rounded-lg -mx-1 mb-4 flex justify-between"><span>Lohn-Check</span><span className="text-[9px] opacity-50 normal-case tracking-normal text-pe-muted dark:text-slate-400 font-sans">Faktor: {settings.global.Wochensatz || 4.33}</span></h3>
                        <div className="grid grid-cols-3 gap-4 mb-4 items-end border-b border-pe-border dark:border-[#1a1a1a] pb-4">
                            <div className="relative"><label className="hr-label">Std.Lohn</label><div className="input-wrapper"><input type="text" id="r1_stdlohn" className="table-input" defaultValue="18,00" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcRechner1()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">{currencyLabel}</span></div></div></div>
                            <div className="relative"><label className="hr-label">Wo.Std</label><div className="input-wrapper"><input type="text" id="r1_wostd" className="table-input" defaultValue="35,00" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcRechner1()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">Std.</span></div></div></div>
                            <div className="relative"><label className="hr-label text-center text-pe-accent-text dark:text-[#E6C299]">Brutto</label><div className="result-wrapper"><div id="r1_result" className="table-calc">2.727,90</div><div className="unit-label"><span className="unit-text">{currencyLabel}</span></div></div></div>
                        </div>
                        <div className="grid grid-cols-3 gap-4 mb-4 items-end border-b border-pe-border dark:border-[#1a1a1a] pb-4">
                            <div className="relative"><label className="hr-label">Monat {currencyLabel}</label><div className="input-wrapper"><input type="text" id="r2_brutto" className="table-input" defaultValue="1.700,00" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcRechner2()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">{currencyLabel}</span></div></div></div>
                            <div className="relative"><label className="hr-label">Wo.Std</label><div className="input-wrapper"><input type="text" id="r2_wostd" className="table-input" defaultValue="30,00" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcRechner2()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">Std.</span></div></div></div>
                            <div className="relative"><label className="hr-label text-center text-pe-accent-text dark:text-[#E6C299]">{currencyLabel} / Std</label><div className="result-wrapper"><div id="r2_result" className="table-calc">13,09</div><div className="unit-label"><span className="unit-text">{currencyLabel}</span></div></div></div>
                        </div>
                        <div className="grid grid-cols-3 gap-4 items-end">
                            <div className="relative"><label className="hr-label">Monat {currencyLabel}</label><div className="input-wrapper"><input type="text" id="r3_brutto" className="table-input" defaultValue="974,25" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcRechner3()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">{currencyLabel}</span></div></div></div>
                            <div className="relative"><label className="hr-label">Wunsch {currencyLabel}</label><div className="input-wrapper"><input type="text" id="r3_stdlohn" className="table-input" defaultValue="15,50" onFocus={(e) => e.target.select()} onBlur={(e) => (window as any).formatNumberField(e.target)} onInput={() => (window as any).calcRechner3()} onKeyDown={(e) => (window as any).handleEnter(e, e.target)} /><div className="unit-label"><span className="unit-text">{currencyLabel}</span></div></div></div>
                            <div className="relative"><label className="hr-label text-center text-pe-accent-text dark:text-[#E6C299]">Max Std</label><div className="result-wrapper"><div id="r3_result" className="table-calc">14,52</div><div className="unit-label"><span className="unit-text">Std.</span></div></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* SECTION B: DATABASE */}
        <div className="table-container-full flex flex-col gap-8">
            
            {/* 1. BESTANDSDATEN */}
            <div className="carbon-panel shadow-2xl overflow-hidden bg-pe-card dark:bg-[#030303]">
                <div className="carbon-content">
                    <div className="pe-accordion-header carbon-weave-bg" onClick={() => toggleSection('existing')}>
                        <div className="pe-accordion-title">
                            <i className={`fas fa-chevron-down section-toggle-icon ${!collapsed.existing ? 'open' : ''}`}></i>
                            <span className="flex items-center gap-2"><i className="fas fa-users text-pe-muted dark:text-slate-400"></i> Bestands-Mitarbeiter (Stammdaten & Austritte)</span>
                        </div>
                        <span className="pe-helper-text">(zum Bearbeiten oder Kündigen aufklicken)</span>
                    </div>
                    
                    <div className={collapsed.existing ? 'hidden' : 'p-6 pt-2'}>
                        <div className="flex items-center gap-4 mb-4 mt-2">
                            <div className="info-box mb-0"><i className="fas fa-info-circle text-pe-accent-text dark:text-[#E6C299]"></i><span className="font-sans">WICHTIG: Erst Datum, dann Name. 'Enter' = Weiter. <strong className="text-red-600 dark:text-red-400 ml-2">Für Kündigungen: Bereich auf "Austritt" setzen.</strong> <span className="text-stone-500 dark:text-slate-500 font-bold ml-4 border-l border-pe-border dark:border-[#333] pl-4">GRAU HINTERLEGT = IST-ZUSTAND</span></span></div>
                            <div id="legalInfoExisting" className="text-base text-pe-muted dark:text-slate-300 font-mono"></div>
                        </div>
                        
                        <ExistingStaffTable onAdminLock={(id, isLocked) => handleAdminLock(id, 'existingStaff', isLocked)} />
                    </div>
                </div>
            </div>

            {/* 2. NEUE MITARBEITER */}
            <div className="carbon-panel shadow-2xl overflow-hidden bg-pe-card dark:bg-[#030303]">
                <div className="carbon-content">
                    <div className="pe-accordion-header carbon-weave-bg" onClick={() => toggleSection('newStaff')}>
                        <div className="pe-accordion-title">
                            <i className={`fas fa-chevron-down section-toggle-icon ${!collapsed.newStaff ? 'open' : ''}`}></i>
                            <span className="flex items-center gap-2"><i className="fas fa-user-plus text-pe-muted dark:text-slate-400"></i> Neue Mitarbeiter</span>
                        </div>
                        <span className="pe-helper-text">(zum Bearbeiten aufklicken)</span>
                    </div>

                    <div className={collapsed.newStaff ? 'hidden' : 'p-6 pt-2'}>
                        <div className="flex items-center gap-4 mb-4 mt-2">
                            <div className="info-box mb-0"><i className="fas fa-info-circle text-pe-accent-text dark:text-[#E6C299]"></i><span className="font-sans">Erst Datum, dann Name eintragen.</span></div>
                            <div id="legalInfoNew" className="text-base text-pe-muted dark:text-slate-300 font-mono"></div>
                        </div>
                        
                        <NewStaffTable onAdminLock={(id, isLocked) => handleAdminLock(id, 'newStaff', isLocked)} />
                    </div>
                </div>
            </div>

            {/* 3. UNTERNEHMER */}
            <div className="carbon-panel shadow-2xl overflow-hidden bg-pe-card dark:bg-[#030303]">
                <div className="carbon-content">
                    <div className="pe-accordion-header carbon-weave-bg" onClick={() => toggleSection('entrepreneur')}>
                        <div className="pe-accordion-title">
                            <i className={`fas fa-chevron-down section-toggle-icon ${!collapsed.entrepreneur ? 'open' : ''}`}></i>
                            <span className="flex items-center gap-2"><i className="fas fa-user-tie text-pe-muted dark:text-slate-400"></i> Unternehmer / Inhaber</span>
                        </div>
                        <span className="pe-helper-text">(zum Bearbeiten aufklicken)</span>
                    </div>

                    <div className={collapsed.entrepreneur ? 'hidden' : 'p-6 pt-4'}>
                        <EntrepreneurTable onAdminLock={(id, isLocked) => handleAdminLock(id, 'entrepreneur', isLocked)} />
                    </div>
                </div>
            </div>

            {/* 4. MANDANTENDATEN */}
            <div className="carbon-panel shadow-2xl overflow-hidden bg-pe-card dark:bg-[#030303]">
                <div className="carbon-content">
                    <div className="pe-accordion-header carbon-weave-bg" onClick={() => toggleSection('clientData')}>
                        <div className="pe-accordion-title">
                            <i className={`fas fa-chevron-down section-toggle-icon ${!collapsed.clientData ? 'open' : ''}`}></i>
                            <span className="flex items-center gap-2"><i className="fas fa-address-card text-pe-muted dark:text-slate-400"></i> Mandantendaten (Stammdaten)</span>
                        </div>
                        <span className="pe-helper-text">(zum Bearbeiten aufklicken)</span>
                    </div>

                    <div className={collapsed.clientData ? 'hidden' : 'p-6 pt-4'}>
                        <ClientMasterTable onAdminLock={(id, isLocked) => handleAdminLock(id, 'clientMaster', isLocked)} />
                    </div>
                </div>
            </div>

            {/* 5. UNTERNEHMENSKOSTEN */}
            <div className="carbon-panel shadow-2xl overflow-hidden bg-pe-card dark:bg-[#030303]">
                <div className="carbon-content">
                    <div className="pe-accordion-header carbon-weave-bg" onClick={() => toggleSection('costs')}>
                        <div className="pe-accordion-title">
                            <i className={`fas fa-chevron-down section-toggle-icon ${!collapsed.costs ? 'open' : ''}`}></i>
                            <span className="flex items-center gap-2"><i className="fas fa-building text-pe-muted dark:text-slate-400"></i> Unternehmenskosten</span>
                        </div>
                        <span className="pe-helper-text">(zum Bearbeiten aufklicken)</span>
                    </div>

                    <div className={collapsed.costs ? 'hidden' : 'p-6 pt-2'}>
                        <div className="info-box mb-4 mt-2 border-l-yellow-500"><i className="fas fa-exclamation-triangle text-yellow-500 mr-2"></i><span className="text-yellow-100 font-bold font-sans">ACHTUNG: Nur <u>monatliche Netto-Kosten</u>! (Jahresbetrag / 12)</span></div>
                        <CostsTable onAdminLock={(id, isLocked) => handleAdminLock(id, 'costs', isLocked)} />
                    </div>
                </div>
            </div>

            {/* 6. ÖFFNUNGSZEITEN */}
            <div className="carbon-panel shadow-2xl overflow-hidden bg-pe-card dark:bg-[#030303]">
                <div className="carbon-content">
                    <div className="pe-accordion-header carbon-weave-bg" onClick={() => toggleSection('hours')}>
                        <div className="pe-accordion-title">
                            <i className={`fas fa-chevron-down section-toggle-icon ${!collapsed.hours ? 'open' : ''}`}></i>
                            <span className="flex items-center gap-2"><i className="fas fa-clock text-pe-muted dark:text-slate-400"></i> Geöffnete Stunden</span>
                        </div>
                        <span className="pe-helper-text">(zum Bearbeiten aufklicken)</span>
                    </div>

                    <div className={collapsed.hours ? 'hidden' : 'p-6 pt-4'}>
                        <OpeningHoursTable onAdminLock={(id, isLocked) => handleAdminLock(id, 'openingHours', isLocked)} />
                    </div>
                </div>
            </div>
        </div>

        <div
          ref={hScrollRef}
          className="az-fixed-hscroll"
          aria-label="Horizontaler Tabellen-Scroll"
          title="Tabelle horizontal scrollen"
        >
          <div ref={hSpacerRef} style={{ height: 1, width: '100%' }} />
        </div>

        <div className="floating-action-bar">
            <button className="fab-btn btn-clean" onClick={saveAndClean}><i className="fas fa-save"></i> Speichern & Bereinigen</button>
            <button id="submitBtn" className="fab-btn btn-submit disabled" onClick={handleOpenSendModal}><i className="fas fa-paper-plane"></i> Absenden</button>
        </div>
      </main>

      <StaffBonusOverviewModal
        isOpen={bonusModalOpen}
        onClose={() => setBonusModalOpen(false)}
        currencySymbol={currencyLabel === 'CHF' ? 'CHF' : '€'}
      />
    </div>
  );
};

export default AenderungsZentralePage;